import { useFarm } from "@intellync/feedlyncapi";
import React from "react";
import useUser from "./useUser";

export const useIsAccountOwner = () => {
  const QUser = useUser();
  const QFarm = useFarm();
  return React.useMemo(() => QFarm.data?.email === QUser?.username, [QFarm.data, QUser?.username]);
};
